// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicDetails {
    width: 100%;
}

.basicDetailsContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}

.imageContainer {
    width: 90%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0 28px 0;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.imageContainerText {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin-bottom: 16px;
}

.coverPhotoText {
    color: #FFF;
    font-family: "Inter", sans-serif;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.2px;
}

.editText {
    color: #5AAF9A;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.15s ease;
}

.editText:hover {
    color: #48D1CC;
    text-decoration: underline;
}

.coverPhotoContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.coverPhoto {
    height: 38vh;
    min-height: 240px;
    max-height: 420px;
    width: 90%;
    object-fit: cover;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 64px;
    font-weight: 700;
    background-color: #142424;
    color: #FFFFFF;
}

.nameContainer {
    width: 90%;
    min-height: 82px;
    height: auto;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 18px 24px;
    display: flex;
    box-sizing: border-box;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.nameContainer:hover {
    border-color: #2F4545;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}

.nameTextContainer {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1;
    min-width: 0;
}

.nameText {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.2px;
    line-height: 1.3;
}

.nameValueText {
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    word-break: break-word;
}

.editIconContainer {
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 10px;
    width: 38px;
    height: 38px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #5AAF9A;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.editIconContainer:hover {
    background-color: #5AAF9A;
    color: #0E1B1B;
    border-color: #5AAF9A;
    transform: scale(1.06);
}

.editIconContainer .editIcon {
    font-size: 18px;
    color: inherit;
}

.dobContainer {
    width: 90%;
    min-height: 82px;
    height: auto;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 18px 24px;
    display: flex;
    box-sizing: border-box;
    gap: 10px;
    flex-direction: column;
    justify-content: center;
}

@media (max-width: 1440px) {
    .nameContainer {
        padding: 16px 20px;
    }
    .nameText {
        font-size: 13px;
    }
    .nameValueText {
        font-size: 15px;
    }
    .coverPhotoText {
        font-size: 16px;
    }
}

@media (max-width: 1024px) {
    .nameContainer {
        padding: 14px 18px;
        gap: 12px;
    }
    .nameText {
        font-size: 12px;
    }
    .nameValueText {
        font-size: 14px;
    }
    .editIconContainer {
        width: 34px;
        height: 34px;
    }
    .editIconContainer .editIcon {
        font-size: 16px;
    }
}

@media (max-width: 768px) {
    .imageContainer,
    .nameContainer {
        width: 95%;
        padding: 14px 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/BasicDetails/BasicDetails.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,wDAAwD;IACxD,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;;QAEI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\n.BasicDetails {\n    width: 100%;\n}\n\n.basicDetailsContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n}\n\n.imageContainer {\n    width: 90%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 0 28px 0;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.imageContainerText {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 90%;\n    margin-bottom: 16px;\n}\n\n.coverPhotoText {\n    color: #FFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n}\n\n.editText {\n    color: #5AAF9A;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: color 0.15s ease;\n}\n\n.editText:hover {\n    color: #48D1CC;\n    text-decoration: underline;\n}\n\n.coverPhotoContainer {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.coverPhoto {\n    height: 38vh;\n    min-height: 240px;\n    max-height: 420px;\n    width: 90%;\n    object-fit: cover;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 64px;\n    font-weight: 700;\n    background-color: #142424;\n    color: #FFFFFF;\n}\n\n.nameContainer {\n    width: 90%;\n    min-height: 82px;\n    height: auto;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 18px 24px;\n    display: flex;\n    box-sizing: border-box;\n    gap: 16px;\n    justify-content: space-between;\n    align-items: center;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.nameContainer:hover {\n    border-color: #2F4545;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);\n}\n\n.nameTextContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1;\n    min-width: 0;\n}\n\n.nameText {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n    line-height: 1.3;\n}\n\n.nameValueText {\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.5;\n    word-break: break-word;\n}\n\n.editIconContainer {\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 10px;\n    width: 38px;\n    height: 38px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #5AAF9A;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n}\n\n.editIconContainer:hover {\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    border-color: #5AAF9A;\n    transform: scale(1.06);\n}\n\n.editIconContainer .editIcon {\n    font-size: 18px;\n    color: inherit;\n}\n\n.dobContainer {\n    width: 90%;\n    min-height: 82px;\n    height: auto;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 18px 24px;\n    display: flex;\n    box-sizing: border-box;\n    gap: 10px;\n    flex-direction: column;\n    justify-content: center;\n}\n\n@media (max-width: 1440px) {\n    .nameContainer {\n        padding: 16px 20px;\n    }\n    .nameText {\n        font-size: 13px;\n    }\n    .nameValueText {\n        font-size: 15px;\n    }\n    .coverPhotoText {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .nameContainer {\n        padding: 14px 18px;\n        gap: 12px;\n    }\n    .nameText {\n        font-size: 12px;\n    }\n    .nameValueText {\n        font-size: 14px;\n    }\n    .editIconContainer {\n        width: 34px;\n        height: 34px;\n    }\n    .editIconContainer .editIcon {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .imageContainer,\n    .nameContainer {\n        width: 95%;\n        padding: 14px 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
